import { LoadingButton } from "@mui/lab";
import { Autocomplete, CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Radio, RadioGroup, Stack, TextField, Typography, FormHelperText, Select, MenuItem, Checkbox, ListItemText } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { ClearIcon } from '@mui/x-date-pickers';
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import Palette from '../theme/palette';
import ReactQuill from 'react-quill';
import { apipost } from "../service/api";
import { fetchTemplateData } from "../redux/slice/emailTemplateSlice";


export default function EmailModel(props) {
  const { open, onClose, ids, setUserAction, module } = props;

  const [err, setErr] = useState('')
  const [messageType, setMessageType] = useState("own");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch()
  const emailTemplateData = useSelector((state) => state?.tempDetails?.data)
  const userdata = JSON.parse(sessionStorage.getItem('user'));
  const userDetails = useSelector((state) => state?.userDetails?.data)

  const initialValues = {
    ids: [...ids],
    message: "",
    subject: "",
    createdBy: userdata?._id,
    html: "",
    cc: "",
    bcc: [],
    agency_id: userdata?.agency_id,
  }

  const validationSchema = yup.object({
    subject: yup.string().required("Subject is required"),
  });
  const sendEmail = async (values) => {
    setIsLoading(true)

    try {
        const data = values;
        const url = module.toLowerCase() === 'lead' ? `api/lead/email` : `api/contact/email`
        const result = await apipost(url, data)
        setUserAction(result)
    } catch (error) {
        console.log(error);
    }
    handleClose();
    formik.resetForm();
    setIsLoading(false)
  }

  // formik
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    validate: (values) => {
        const errors = {};
        if (messageType === 'own' && !values.message) {
            errors.message = 'Message is required';
        } else if (messageType === 'template' && !values.html) {
          errors.html = 'Template is required';
        }
        return errors;
    },
    onSubmit: (values) => {
      handleSubmit(values)
    },
  });


  const handleSubmit = (payload) => {
    sendEmail(payload)
    formik.resetForm()
  }

  const handleClose = () => {
    formik.resetForm();
    onClose();
    setErr("");
  };

  const handleMessageTypeChange = (e) => {
    setMessageType(e.target.value);
    formik.setFieldValue('message', '');
    formik.setFieldValue('html', '');
  };


  useEffect(() => {
    if (emailTemplateData.length === 0) {
        dispatch(fetchTemplateData())
    }
  }, [open])


  return (
    <div>

      <Dialog
        open={open}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",

          }}
        >
          <Typography variant="h6">Send SMS</Typography>
          <Typography>
            <ClearIcon
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <form>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
            >
              <Grid
                container
                rowSpacing={2}
              // columnSpacing={{ xs: 0, sm: 5, md: 4 }}
              >
                <Grid item xs={12} sm={12} md={12}>
                <FormLabel>Subject</FormLabel>
                <TextField
                    id="subject"
                    name="subject"
                    size="small"
                    fullWidth
                    value={formik.values.subject}
                    onChange={formik.handleChange}
                    error={
                        formik.touched.subject &&
                        Boolean(formik.errors.subject)
                    }
                    helperText={
                        formik.touched.subject && formik.errors.subject
                    }
                />
            </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormLabel>Cc </FormLabel>
                    <FormControl fullWidth>
                    <Select
                        labelId="demo-simple-select-label"
                        id="cc"
                        name="cc"
                        label=""
                        size='small'
                        fullWidth
                        value={formik.values.cc}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.cc &&
                            Boolean(formik.errors.cc)
                        }
                        helperText={
                            formik.touched.cc && formik.errors.cc
                        }
                        >
                        {
                            userDetails?.map((item) => {
                            return (
                                <MenuItem key={item.emailAddress} value={item.emailAddress}>
                                {`${item.firstName} ${item.lastName}`}
                                </MenuItem>
                            );
                            })
                        }
                    </Select>
                        </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormLabel>Bcc </FormLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="bcc"
                        name="bcc"
                        size="small"
                        multiple
                        value={formik.values.bcc}
                        onChange={formik.handleChange}
                        error={formik.touched.bcc && Boolean(formik.errors.bcc)}
                        renderValue={(selected) => (
                            <div>
                                {
                                    selected.map((value) => {
                                        const userData = userDetails.find((user) => user.emailAddress === value)
                                        return (
                                            <div key={value}>
                                                {`${userData?.firstName} ${userData?.lastName}`}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )}
                    >
                        {
                            userDetails?.map((user) => (
                                <MenuItem value={user?.emailAddress}>
                                    <Checkbox checked={formik.values.bcc.indexOf(user?.emailAddress) > -1} />
                                    <ListItemText primary={`${user?.firstName} ${user?.lastName}`} />
                                </MenuItem>
                            ))
                        }
                    </Select>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormLabel>Message Type<span style={{ color: "red" }}>*</span></FormLabel>
                  <RadioGroup
                    row
                    name="messageType"
                    value={messageType}
                    onChange={handleMessageTypeChange}
                  >
                    <FormControlLabel value="own" control={<Radio />} label="Own" />
                    <FormControlLabel value="template" control={<Radio />} label="Template" />
                  </RadioGroup>
                </Grid>
                {messageType === 'template' && (
                    <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                            <Autocomplete
                                id="lead-autocomplete"
                                options={emailTemplateData}
                                getOptionLabel={(template) => template?.name}
                                value={emailTemplateData.find(template => template?.html === formik.values.html) || null}
                                onChange={(event, newValue) => {
                                    formik.setFieldValue("html", newValue ? newValue?.html : "");
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        name="html"
                                        error={formik.touched.html && Boolean(formik.errors.html)}
                                        helperText={formik.touched.html && formik.errors.html}
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                )}
                {messageType === 'own' && (
                    <Grid item xs={12} sm={12} md={12}>
                        {/* <FormLabel>Message</FormLabel> */}
                        <ReactQuill
                            name="message"
                            value={formik.values.message}
                            onChange={(value) => formik.setFieldValue('message', value)}
                            disabled={messageType === 'template'}
                        />
                        <FormHelperText error={formik.touched.message && Boolean(formik.errors.message)}>
                            {formik.touched.message && formik.errors.message}
                        </FormHelperText>
                    </Grid>
                )}
              </Grid>
            </DialogContentText>
          </form>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={2}>
            <LoadingButton onClick={formik.handleSubmit} variant='contained' color='secondary' disabled={!!isLoading}>
              {isLoading ? <CircularProgress size={27} /> : 'Send'}
            </LoadingButton>
            <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </div>
  );
}
